var sections = $('section')
  , nav = $('.sidenav--links')
  , nav_height = $('.container-header').outerHeight();


  $(window).on('scroll', function () {
	var cur_pos = $(this).scrollTop();
	
	sections.each(function() {
		var top = $(this).offset().top - nav_height,
			bottom = top + $(this).outerHeight();
	
		if (cur_pos >= top && cur_pos <= bottom) {
		nav.find('.anchor--link').removeClass('active');
		sections.removeClass('active');
	
		$(this).addClass('active');
		nav.find('a[href="#'+$(this).attr('id')+'"]').addClass('active');
		}
	});

});